// Admin switch `useClasswiseRiceNorms` (default OFF). OFF = legacy shared-group
// rice in the Quarterly UC and Dry Ration Report; ON = each class's own norm.
const LS_KEY = "mdm.useClasswiseRiceNorms";
let on = (() => { try { return localStorage.getItem(LS_KEY) === "1"; } catch { return false; } })();
export function setUseClasswiseRiceNorms(v) {
  const next = !!v;
  try { localStorage.setItem(LS_KEY, next ? "1" : "0"); } catch { /* ignore */ }
  const changed = next !== on;
  on = next;
  return changed;
}
export function isClasswiseRiceNorms() { return on; }
